import { createContext, useCallback, useContext, useState } from 'react';

// Getting a conflict with Prettier here.
// eslint-disable-next-line no-spaced-func
const WistiaVideoContext = createContext<{
  isWistiaOnThePage: boolean;
  setIsWistiaOnThePage: () => void;
}>({
  isWistiaOnThePage: false,
  setIsWistiaOnThePage: () => {},
});

type Props = {
  children: React.ReactNode;
};

export function WistiaVideoProvider({ children }: Props) {
  const [isWistiaOnThePage, setIsWistiaOnThePage] = useState(false);
  const updateWistiaState = useCallback(() => setIsWistiaOnThePage(true), []);

  const value = {
    isWistiaOnThePage,
    setIsWistiaOnThePage: updateWistiaState,
  };

  return (
    <WistiaVideoContext.Provider value={value}>
      {children}
    </WistiaVideoContext.Provider>
  );
}

export function useWistiaScript() {
  const context = useContext(WistiaVideoContext);

  if (context === undefined) {
    throw new Error('useWistiaScript must be used within a WistiaProvider');
  }

  return context;
}
